import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import semver from 'semver';

function VersionControl(props) {

    const requiredVersion = '1.8.10';
    let [isLoading, setIsLoading] = useState(true);
    let { licenseName } = useParams();
    let [license] = useState(licenseName);
    let [customerVersionStatus, setCustomerVersionStatus] = useState();
    let [customerVersion, setCustomerVersion] = useState();
    let [migratedCustomers, _] = useState(
        process.env.REACT_APP_MIGRATED_LICENSES.split(',')
    );

    useEffect(() => {
        const callApi = async () => {
            const query = `/api/${license}/version`;
            const res = await fetch(query,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                });
            // 403 - no settings
            // 404 - no license
            if (res.status === 200) {
                const resJson = await res.json();
                if (semver.lt(resJson.version, requiredVersion)) {
                    setCustomerVersion(resJson.version);
                    setCustomerVersionStatus(403);
                }
                else {
                    setCustomerVersionStatus(200);
                }
            }
            else {
                setCustomerVersion(res.status);
            }
            setIsLoading(false);
        }
        callApi();
    }, [license])

    if (isLoading) {
        return <div></div>
    }
    else {
//        if (migratedCustomers.includes(license)) {
	    // Redirect all traffic to new onlinebooking, since 19/10 2022
            let url = "https://boka.agitura.se/" + license;
            window.location.href = url;
            //return <Redirect to={url}/>
//        }
        if (customerVersionStatus === 200) {
            return props.children
        }
        else if (customerVersionStatus === 403) {
            return (
                <div>
                    Din version av Agitura Journal är för gammal för att använda
                    onlinebokningen.<br /> Du har version {customerVersion} installerad, men
                    Agitura Portal (onlinebokningen) kräver för närvarande att du kör version {requiredVersion} eller högre.
                    <br /> Klicka <a href="https://agitura.se/nedladdningar">HÄR </a>
                    för att ladda hem den senaste versionen av Agitura Journal.
                </div>
            )
        }
        else {
            return <div></div>;
        }
    }
}

export default VersionControl;
